import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";

import HttpClient from 'services/HttpClient';

const PERFORMANCES_API = '/api/v1/performances';

@withRouter
@inject("userStore")
@inject("alertStore")
@inject("mcqPerformanceStore")
@observer
export class Performance extends Component {
  componentDidMount = () => {
    const {
      alertStore,
      mcqPerformanceStore,
    } = this.props;

    new HttpClient().get(PERFORMANCES_API)
    .then(({ body }) => {
      mcqPerformanceStore.setPerformances(body.data);
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  };

  renderSlider = (correct, incorrect, total) => {
    const correctPercents = correct * 100 / total;
    const incorrectPercents = incorrect * 100 / total;

    return (
      <div className="performance-slider">
        <div className="performance-slider-line correct-line" style={{width: `${correctPercents}%`}} />
        <div className="performance-slider-line incorrect-line" style={{width: `${incorrectPercents}%`}} />
      </div>
    );
  };

  renderLegendProgress = () => {
    const { mcqPerformanceStore: { performances } } = this.props;

    return performance ? (
      <div className="performance-wrapper">
        <div className="performance-header">
          <h3>Legend Progress</h3>
          <div className="performance-instruction">
            <div className="performance-dots-wrapper">
              <div className="performance-dot correct" />
              <span>Correct answers</span>
            </div>
            <div className="performance-dots-wrapper">
              <div className="performance-dot incorrect" />
              <span>Incorrect answers</span>
            </div>
          </div>
        </div>
        <div className="mcq-card">
          {this.renderSlider(performances.correct_answers, performances.incorrect_answers, performances.total_questions)}
        </div>
      </div>
    ) : null;
  };

  renderCategoryProgress = () => {
    const { mcqPerformanceStore: { performances } } = this.props;

    return performances.performance_by_category ? (
      <div className="performance-wrapper">
        <div className="performance-header">
          <h3>Performance by Category</h3>
        </div>
        <div className="perforance-category-wrapper">
          {performances.performance_by_category.map((byCategory, index) => (
            <div key={`performance_by_category_${index}`} className="perforance-category">
              <span>{byCategory.theme}</span>
              <div className="mcq-card">
                <p className="categrory-calc">{`${byCategory.correct}/${byCategory.total}`}</p>
                {this.renderSlider(byCategory.correct, byCategory.incorrect, byCategory.total)}
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : null;
  };

  render() {
    return (
      <div className="mcq-tab">
        <h3>Performance Summary - All Sessions</h3>
        <div className="mcq-dashboard">
          {this.renderLegendProgress()}
          {this.renderCategoryProgress()}
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/mcq/components/Performance.js